import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_EMAIL_MANAGEMENT_REQUEST,
    FETCH_EMAIL_MANAGEMENT_SUCCESS,
    FETCH_EMAIL_MANAGEMENT_FAILURE,
    FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST,
    FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS,
    FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE,
    CREATE_EMAIL_MANAGEMENT_REQUEST,
    CREATE_EMAIL_MANAGEMENT_SUCCESS,
    CREATE_EMAIL_MANAGEMENT_FAILURE,
    UPDATE_EMAIL_MANAGEMENT_REQUEST,
    UPDATE_EMAIL_MANAGEMENT_SUCCESS,
    UPDATE_EMAIL_MANAGEMENT_FAILURE,
    DELETE_EMAIL_MANAGEMENT_REQUEST,
    DELETE_EMAIL_MANAGEMENT_SUCCESS,
    DELETE_EMAIL_MANAGEMENT_FAILURE,
} from '../actions/emailManagementActions';
import {
    getEmailManagement,
    getEmailManagementById,
    createEmailManagement,
    updateEmailManagement,
    deleteEmailManagement,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* fetchEmailManagementSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getEmailManagement, params);
        yield put({ type: FETCH_EMAIL_MANAGEMENT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de l\'email management');
        yield put({ type: FETCH_EMAIL_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* fetchEmailManagementByIdSaga(action) {
    try {
        const data = yield call(getEmailManagementById, action.payload);
        yield put({ type: FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement de l\'email management');
        yield put({ type: FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createEmailManagementSaga(action) {
    try {
        const { partnerId, emailManagementData } = action.payload;
        const data = yield call(createEmailManagement, partnerId, emailManagementData);
        yield put({ type: CREATE_EMAIL_MANAGEMENT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création de l\'email management');
        yield put({ type: CREATE_EMAIL_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* updateEmailManagementSaga(action) {
    try {
        const { emailManagementId, emailManagementData } = action.payload;
        const data = yield call(updateEmailManagement, emailManagementId, emailManagementData);
        yield put({ type: UPDATE_EMAIL_MANAGEMENT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour de l\'email management');
        yield put({ type: UPDATE_EMAIL_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

function* deleteEmailManagementSaga(action) {
    try {
        const data = yield call(deleteEmailManagement, action.payload);
        const emailManagementId = data?.data?.email_management_id || action.payload;
        yield put({
            type: DELETE_EMAIL_MANAGEMENT_SUCCESS,
            payload: {
                email_management_id: emailManagementId,
                message: data?.message || 'Email management deleted successfully.',
            },
        });
    } catch (error) {
        const detail = error?.response?.data?.detail;
        const errorMessage = typeof detail === 'string' && detail.trim()
            ? detail
            : handleApiError(error, 'Erreur lors de la suppression de l\'email management');
        yield put({ type: DELETE_EMAIL_MANAGEMENT_FAILURE, payload: errorMessage });
    }
}

export function* watchEmailManagementRequests() {
    yield takeEvery(FETCH_EMAIL_MANAGEMENT_REQUEST, fetchEmailManagementSaga);
    yield takeEvery(FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST, fetchEmailManagementByIdSaga);
    yield takeEvery(CREATE_EMAIL_MANAGEMENT_REQUEST, createEmailManagementSaga);
    yield takeEvery(UPDATE_EMAIL_MANAGEMENT_REQUEST, updateEmailManagementSaga);
    yield takeEvery(DELETE_EMAIL_MANAGEMENT_REQUEST, deleteEmailManagementSaga);
}

